module.exports = __webpack_public_path__ + "static/media/sound-selection.f00692ba.mp3";